import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AcknowledgementManagementComponent } from './acknowledgement-management/acknowledgement-management.component';
import { AcknowledgementSliderComponent } from './acknowledgement-slider/acknowledgement-slider.component';
import { AcknowledgementCreationComponent } from './acknowledgement-slider/acknowledgement-creation/acknowledgement-creation.component';

import { BptProgressSpinnerModule } from 'bpt-ui-library/bpt-progress-spinner';
import { BptDateTimeModule } from 'bpt-ui-library/bpt-datetime';
import { ButtonModule } from 'primeng/button';
import { BptDropdownModule } from 'bpt-ui-library/bpt-dropdown';
import { InputTextareaModule} from 'primeng/inputtextarea';
import { ToastModule } from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { BptTextInputModule } from 'bpt-ui-library/bpt-text-input';
import { PanelModule } from 'primeng/panel';
import { SharedModule } from '../shared/shared.module';
import { DialogModule } from 'primeng/dialog';
import { FieldsetModule } from 'primeng/fieldset';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { DeleteAcknowledgementComponent } from './delete-acknowledgement/delete-acknowledgement.component';
import { EmptyResultsComponent } from '../shared-components/empty-results/empty-results.component';
import { SpinnerComponent } from '../shared-components/spinner/spinner.component';
import { LabelComponent } from '../shared-components/label/label.component';

@NgModule({
  declarations: [
    AcknowledgementManagementComponent,
    AcknowledgementSliderComponent,
    AcknowledgementCreationComponent,
    DeleteAcknowledgementComponent
  ],
  imports: [
    CommonModule,    
    ButtonModule,
    FieldsetModule,
    FormsModule,
    ReactiveFormsModule,
    BptDropdownModule,
    InputTextareaModule,
    ToastModule,
    MessagesModule,
    ConfirmDialogModule,
    BptTextInputModule,
    BptDateTimeModule,
    PanelModule,
    SharedModule,
    DialogModule,
    BptProgressSpinnerModule,
    TooltipModule,
    EmptyResultsComponent,
    SpinnerComponent,
    LabelComponent
  ],
  exports:[
    AcknowledgementManagementComponent
  ]
})
export class DocumentAcknowledgementModule { }
